enum ReviewsActions {
    FETCH_LIST = "reviewsFetchList",
    GET_ITEM = "reviewsGetItem",
    CREATE_ITEM = "reviewsCreateItem",
    UPDATE_ITEM = "reviewsUpdateItem",
    DELETE_ITEM = "reviewsDeleteItem",
    REFRESH_LIST = "reviewsRefreshList",
    UPDATE_TRANSLATION = "reviewsUpdateTranslation",
    IMPORT_REVIEWS = "reviewsImportReviews",
    ADD_IMAGE = "reviewsAddImage",
    DELETE_IMAGE = "reviewsDeleteImage",
}

enum ReviewsMutation {
    SET_RENDER_UPDATE = "reviewsListRenderNeeded",
    SET_LIST_RESULT = "reviewsListResult"
}

export {ReviewsActions, ReviewsMutation};
